'use strict';

let EventPubSub = require('./es5');
if(process.version[1]>5){
    EventPubSub = require('./es6');
}

module.exports=EventPubSub;



//////////////////
// WEBPACK FOOTER
// ./~/event-pubsub/event-pubsub.js
// module id = 122
// module chunks = 0 1